import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTSendMacroAndRefundFullOrderRBINode from '../NodeGroups/DTCopyTextSendMacro/DTSendMacroAndRefundFullOrderRBINode/DTSendMacroAndRefundFullOrderRBINode';

const SendMacroAndRefundFullOrderRbi = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTSendMacroAndRefundFullOrderRBINode
      showConfirmation={showConfirmationPage}
      message={'The full order refund has been processed.'}
    />
  );
};

export default SendMacroAndRefundFullOrderRbi;
